"use strict";
/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var observables_1 = require("@jupyterlab/observables");

var coreutils_1 = require("@phosphor/coreutils");

var signaling_1 = require("@phosphor/signaling");
/**
 * The default implementation of a notebook attachment model.
 */


var AttachmentModel = /*#__PURE__*/function () {
  /**
   * Construct a new attachment model.
   */
  function AttachmentModel(options) {
    _classCallCheck(this, AttachmentModel);

    // All attachments are untrusted
    this.trusted = false;
    this._changed = new signaling_1.Signal(this);
    this._raw = {};

    var _Private$getBundleOpt = Private.getBundleOptions(options),
        data = _Private$getBundleOpt.data;

    this._data = new observables_1.ObservableJSON({
      values: data
    });
    this._rawData = data; // Make a copy of the data.

    var value = options.value;

    for (var key in value) {
      // Ignore data and metadata that were stripped.
      switch (key) {
        case 'data':
          break;

        default:
          this._raw[key] = Private.extract(value, key);
      }
    }
  }
  /**
   * A signal emitted when the attachment model changes.
   */


  _createClass(AttachmentModel, [{
    key: "changed",
    get: function get() {
      return this._changed;
    }
    /**
     * Dispose of the resources used by the attachment model.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this._data.dispose();

      signaling_1.Signal.clearData(this);
    }
    /**
     * The data associated with the model.
     */

  }, {
    key: "data",
    get: function get() {
      return this._rawData;
    }
    /**
     * The metadata associated with the model.
     */

  }, {
    key: "metadata",
    get: function get() {
      return undefined;
    }
    /**
     * Set the data associated with the model.
     *
     * #### Notes
     * Depending on the implementation of the mime model,
     * this call may or may not have deferred effects,
     */

  }, {
    key: "setData",
    value: function setData(options) {
      if (options.data) {
        this._updateObservable(this._data, options.data);

        this._rawData = options.data;
      }

      this._changed.emit(void 0);
    }
    /**
     * Serialize the model to JSON.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var attachment = {};

      for (var key in this._raw) {
        attachment[key] = Private.extract(this._raw, key);
      }

      return attachment;
    }
    /**
     * Update an observable JSON object using a readonly JSON object.
     */

  }, {
    key: "_updateObservable",
    value: function _updateObservable(observable, data) {
      var oldKeys = observable.keys();
      var newKeys = Object.keys(data); // Handle removed keys.

      var _iterator = _createForOfIteratorHelper(oldKeys),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _key = _step.value;

          if (newKeys.indexOf(_key) === -1) {
            observable.delete(_key);
          }
        } // Handle changed data.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      for (var _i = 0, _newKeys = newKeys; _i < _newKeys.length; _i++) {
        var key = _newKeys[_i];
        var oldValue = observable.get(key);
        var newValue = data[key];

        if (oldValue !== newValue) {
          observable.set(key, newValue);
        }
      }
    }
  }]);

  return AttachmentModel;
}();

exports.AttachmentModel = AttachmentModel;
/**
 * The namespace for AttachmentModel statics.
 */

(function (AttachmentModel) {
  /**
   * Get the data for an attachment.
   *
   * @params bundle - A kernel attachment MIME bundle.
   *
   * @returns - The data for the payload.
   */
  function getData(bundle) {
    return Private.getData(bundle);
  }

  AttachmentModel.getData = getData;
})(AttachmentModel = exports.AttachmentModel || (exports.AttachmentModel = {}));
/**
 * The namespace for module private data.
 */


var Private;

(function (Private) {
  /**
   * Get the data from a notebook attachment.
   */
  function getData(bundle) {
    return convertBundle(bundle);
  }

  Private.getData = getData;
  /**
   * Get the bundle options given attachment model options.
   */

  function getBundleOptions(options) {
    var data = getData(options.value);
    return {
      data: data
    };
  }

  Private.getBundleOptions = getBundleOptions;
  /**
   * Extract a value from a JSONObject.
   */

  function extract(value, key) {
    var item = value[key];

    if (coreutils_1.JSONExt.isPrimitive(item)) {
      return item;
    }

    return coreutils_1.JSONExt.deepCopy(item);
  }

  Private.extract = extract;
  /**
   * Convert a mime bundle to mime data.
   */

  function convertBundle(bundle) {
    var map = Object.create(null);

    for (var mimeType in bundle) {
      map[mimeType] = extract(bundle, mimeType);
    }

    return map;
  }
})(Private || (Private = {}));